import { RadioProps, Radio } from '@mui/material';
import { styled } from '@mui/material/styles';

const colorBorderRadio = '#ccccce';

export const RadioStyled = styled(Radio)<RadioProps>(({ theme }) => ({
  '&.MuiRadio-root': {
    color: colorBorderRadio,

    '&.Mui-checked': {
      color: theme.palette.tertiary.main,
    },
  },
  '&.MuiRadio-colorPrimary': {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  '&.MuiRadio-colorSecondary': {
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
}));
